import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Person } from '../models/person';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class RiderInvitationCheckService {

  constructor(private http: HttpClient) { }

  checkRiderAccess(horse_show_id: string, entry_type_number: number, rider_list: Person[]): Promise<boolean> {
  	let post_data = {
        data: {
          type: 'rider_invitation_check_request',
          attributes: {
          	horse_show_id: horse_show_id,
          	entry_type_number: entry_type_number,
          	rider_list: rider_list }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'rider_invitation_check',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='rider_invitation_check_response') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : JSON.stringify(error));
                  }
                });
            });
  }

}
